<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import BrandMark from '@/components/layout/BrandMark.vue'
import LocaleSwitcher from '@/components/layout/LocaleSwitcher.vue'
import ThemeToggle from '@/components/layout/ThemeToggle.vue'
import UserMenu from '@/components/layout/UserMenu.vue'
import AppIcon from '@/components/ui/AppIcon.vue'
import { useAuthStore } from '@/stores/auth'
import { useUiStore } from '@/stores/ui'

const { t } = useI18n()
const auth = useAuthStore()
const ui = useUiStore()
</script>

<template>
  <header
    class="sticky top-0 z-20 flex h-16 items-center gap-x-3 border-b border-stone-200/70 bg-white px-4 dark:border-neutral-700 dark:bg-neutral-800"
  >
    <div class="flex shrink-0 items-center justify-center lg:-ms-4 lg:w-64">
      <BrandMark academy collapse />
    </div>

    <button
      type="button"
      class="rounded-lg p-2 text-gray-500 hover:bg-gray-100 lg:hidden dark:hover:bg-neutral-700"
      :aria-label="ui.sidebarOpen ? t('nav.closeMenu') : t('nav.openMenu')"
      :aria-expanded="ui.sidebarOpen"
      @click="ui.toggleSidebar()"
    >
      <AppIcon name="menu" />
    </button>

    <div class="ms-auto flex items-center gap-x-3">
      <slot name="actions" />
      <ThemeToggle />
      <LocaleSwitcher />
      <UserMenu v-if="auth.isAuthenticated" />
    </div>
  </header>
</template>
